import { getBasePath } from "@/utils/utils";
import { EMAIL_DOMAIN_REDIRECT_CONFIG } from "@home/_config/emailDomainRedirect";

/**
 * 获取邮箱后缀
 * @param email 用户邮箱
 * @returns 邮箱后缀，如果无效则返回 null
 */
export const getEmailDomain = (email: string): string | null => {
  const normalized = (email || '').trim();
  const parts = normalized.split('@');

  if (parts.length !== 2) return null;

  return parts[1].toLowerCase();
};

export const getRedirectUrlByEmail = (email: string): string | null => {
  const domain = getEmailDomain(email);
  if (!domain) return null;

  const config = EMAIL_DOMAIN_REDIRECT_CONFIG.find(
    (item) => item.domains.some((d) => d.toLowerCase() === domain),
  );
  if (!config) return null;

  return `${getBasePath()}${config.redirectPath}`;
};
